<template>
  <base-modal modal-content-class="rest confirm_purch">
    <div class="content">
      <h1>{{ $_getTranslations.home_modals_confirm_purchase_purchase }}</h1>

      <p class="games-to-price">
        <span>{{ getBundleData.numberOfGames }}</span> {{ $_getTranslations.home_modals_confirm_purchase_games }} -
        <span>{{ getBundleData.price }}</span> {{ getBundleData.currencyCode }}
      </p>

      <p>{{ $_translateTextByOperator({key: 'home_modals_confirm_purchase_via_sms_playing_more'}) }}</p>

      <p>
        {{ $_translateTextByOperator({key: 'home_modals_confirm_purchase_via_sms_purchase_now_by_pt1'}) }}
        <b>{{ $_translateTextByOperator({key: 'home_modals_confirm_purchase_via_sms_purchase_now_by_pt2'}) }}</b>
        {{ $_translateTextByOperator({key: 'home_modals_confirm_purchase_via_sms_purchase_now_by_pt3'}) }}
        <b>{{ $_translateTextByOperator({key: 'home_modals_confirm_purchase_via_sms_purchase_now_by_pt4'}) }}</b>
        .
      </p>
    </div>
  </base-modal>
</template>

<script>
/* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import {mapGetters} from 'vuex'
import BaseModal from '../../../common/modal/BaseModal'
import translationMixin from '../../../../common/mixins/translation'

export default {
  name: 'confirmPurchaseViaSms',
  components: {BaseModal},
  mixins: [translationMixin],
  computed: {
    ...mapGetters('profile', [
      'getBundleData'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/store/ConfirmPurchaseViaSms.vue